
class PathAfterLoginHolder {
  storePath(pathAfterLogin) {
    localStorage.pathAfterLogin = pathAfterLogin
  }

  popPath() {
    const defaultPath = '/'
    const path = localStorage.pathAfterLogin ? localStorage.pathAfterLogin : defaultPath
    localStorage.removeItem('pathAfterLogin')
    return path
  }
}

export default new PathAfterLoginHolder()
